import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TimeImpact = () => {
  const { t } = useLanguage();
  const metrics = t.timeImpact.metrics;

  return (
    <section className="py-24 px-6 bg-[#050505] relative">
      <div className="pexadia-watermark"></div>
      <div className="max-w-7xl mx-auto relative z-20">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1.5 mb-6 border border-[#d4af37]/30 rounded-full bg-[#d4af37]/5">
            <span className="text-[10px] font-black tracking-[0.2em] text-gray-400 uppercase">
              {t.timeImpact.badge}
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-serif mb-6 italic">
            {t.timeImpact.title1} <span className="gold-gradient">{t.timeImpact.title2}</span> {t.timeImpact.title3}
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-xl font-light leading-relaxed">
            {t.timeImpact.description}
          </p>
        </div>

        <div className="glass-card rounded-[3rem] p-8 md:p-12 overflow-hidden border-white/10">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="text-left py-4 px-6 text-sm font-black uppercase tracking-widest text-gray-400">
                    {t.timeImpact.table.indicator}
                  </th>
                  <th className="text-left py-4 px-6 text-sm font-black uppercase tracking-widest text-gray-400">
                    {t.timeImpact.table.traditional}
                  </th>
                  <th className="text-left py-4 px-6 text-sm font-black uppercase tracking-widest text-gray-400">
                    <div className="flex items-center gap-2">
                      {t.timeImpact.table.pexadia}
                      <i className="fas fa-bolt text-[#d4af37]"></i>
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 text-sm font-black uppercase tracking-widest text-gray-400">
                    {t.timeImpact.table.impact}
                  </th>
                </tr>
              </thead>
              <tbody>
                {metrics.map((metric, index) => (
                  <tr key={index} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                    <td className="py-6 px-6 text-gray-300 font-medium">
                      {metric.indicator}
                    </td>
                    <td className="py-6 px-6 text-gray-400">
                      {metric.traditional}
                    </td>
                    <td className="py-6 px-6">
                      <span className="font-bold text-white">{metric.pexadia}</span>
                    </td>
                    <td className="py-6 px-6">
                      <div className="flex flex-col">
                        <span className="text-xs text-gray-500 uppercase tracking-widest mb-1">Impact</span>
                        <span className="font-bold gold-gradient text-xl">{metric.impact}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TimeImpact;

